import React, {useState, useEffect} from 'react';
import {notification, Button, Table} from 'antd';
import Spinner from '../../../../spinner';
import {companyService} from '../../../../../services';
import ModalShowRefuseReason from "../../../../modals/show-refuse-reason";
import ModalEditLegalEntityConsignorGosLog from "../../../../modals/edit-legal-entity-consignor-gos-log";
import NotificationMessage from "../../../../modals/notification-message";
import {useFetchNotification} from "../../../../../hooks/use-fetch-notification";
import ModalEditLegalEntityNew from "../../../../modals/edit-legal-entity-new";
import i18n from '../../../../../i18n';
import {contractStatus} from "../../../../../helpers/translate.helpers";

export default function OrdersGosLog() {
  const [needUpdate, setNeedUpdate] = useState(false);
  const [loading, setLoading] = useState(true);
  const [stopListUpdate, setStopListUpdate] = useState(false);

  const [data, setData] = useState(null);

  const [showRefuseReasonModal, setShowRefuseReasonModal] = useState(false);
  const [refuseModalText, setRefuseModalText] = useState('');

  const [isShowEditEntity, setShowEditEntity] = useState(false);
  const [isShowEditEntityDocs, setShowEditEntityDocs] = useState(false);

  const [currentEntityId, setCurrentEntityId] = useState(null);
  const [currentConsignorId, setCurrentConsignorId] = useState(null);
    const [currentStatus, setCurrentStatus] = useState(null);

  const [{notifications}] = useFetchNotification(true);

  const resendOrder = (orderId) => {
    setLoading(true);

    companyService
      .resendOrder(orderId)
      .then(resp => {
        setLoading(false);
        setStopListUpdate(false);
        setNeedUpdate(true);

        notification.success({
          message: i18n.t('components.notification.titles.resendOrder'),
          description: resp.message
        });
      })
      .catch(errMsg => notification.error(
        {
          message: i18n.t('components.notification.titles.resendOrder'),
          description: errMsg
        }));
  };

  const showRefuseModal = (text) => {
    setRefuseModalText(text);
    setShowRefuseReasonModal(true);
  };

  useEffect(() => {
    if (!stopListUpdate) {
      setLoading(true);

      companyService
        .getOrdersGosLogListForCompany()
        .then(resp => {
          setData(resp);
          setLoading(false);
        })
        .catch(errMsg => notification.error(
          {
            message: i18n.t('components.notification.titles.getOrders'),
            description: errMsg
          }));
    }
  }, [needUpdate, stopListUpdate]);

  const handleEditLegalEntity = (entityId, consignorId) => {
    setCurrentEntityId(entityId);
    setCurrentConsignorId(consignorId);
    setShowEditEntity(true);
  };

    const handleEditLegalEntityDocs = (entityId, consignorId, status) => {
        setCurrentEntityId(entityId);
        setCurrentConsignorId(consignorId);
        if (status === 'Ожидает загрузки выписки ГосЛог' || status === 'Отклонено согласование госЛог выписки') {
            setCurrentStatus('6')
        } else {
            setCurrentStatus('1')
        }

        setShowEditEntityDocs(true);
    };

  const columns = [
    {
      title: i18n.t('companyPage.ordersToConsignor.table.legalEntity.title'),
      key: "legalEntity",
      render: (record) => record.legalEntity.name
    },
    {
      title: i18n.t('companyPage.ordersToConsignor.table.consignor.title'),
      key: "consignor",
      render: (record) => record.consignor.name
    },
    {
      title: i18n.t('companyPage.ordersToConsignor.table.status.title'),
      key: "status",
      render: (record) => {
        const status = Object.entries(contractStatus).filter((item) => {
          return item[1] === record.status;
        });
        if (status && status.length > 0) {
          return i18n.t(`constants.contractStatus.${status[0][0]}`);
        } else {
          return record.status
        }
      }
    },
    {
      title: i18n.t('companyPage.ordersToConsignor.table.dateCreated.title'),
      key: "dateCreated",
      render: (record) => record.dateLastSubmissionApprove ? record.dateLastSubmissionApprove : record.dateCreated
    },
    {
      title: "", key: "actions", render: (record) => {
        if (record.status === 'Отклонено' || record.status === 'Отклонено согласование госЛог выписки') {
          return (
            <React.Fragment>
              <Button style={{marginLeft: "0px", width: "100%"}}
                      onClick={() => showRefuseModal(record.refuseData.refuseReason)} size="small"
                      className="small-button typical-btn-blue">{i18n.t('companyPage.ordersToConsignor.buttons.refuseReason')}</Button>
              {/*<Button style={{marginLeft: "0px", width: "100%"}} onClick={() => resendOrder(record.id)} size="small"*/}
              {/*        className="small-button typical-btn-green">{i18n.t('companyPage.ordersToConsignor.buttons.resendOrder')}</Button>*/}
            </React.Fragment>
          );
        }
      }
    },
    {
      title: "", key: "editActions", render: (record) => {
        if (record.status === 'Отклонено' || record.status === 'Ожидает загрузки выписки ГосЛог' || record.status === 'Отклонено согласование госЛог выписки') {
          return (
            <React.Fragment>
              {/*<Button style={{marginLeft: "0px", width: "100%"}} title={i18n.t('main.buttons.edit')} type="primary"*/}
              {/*        icon="edit" htmlType="button" size="small" className="small-button typical-btn-green"*/}
              {/*        onClick={() => handleEditLegalEntity(record.legalEntity.id, record.consignor.id)}/>*/}
              <Button style={{marginLeft: "0px", width: "100%"}} title={i18n.t('main.buttons.editDocs')} type="primary"
                      icon="file-word" htmlType="button" size="small" className="small-button typical-btn-green"
                      onClick={() => handleEditLegalEntityDocs(record.legalEntity.id, record.consignor.id, record.status)}/>
            </React.Fragment>
          );
        }

        return null;
      }
    }
  ];

  return (
    <Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
      <NotificationMessage notifications={notifications} setStopListUpdate={setStopListUpdate} loading={false}/>

      <Table
        columns={columns}
        dataSource={data}
        locale={{emptyText: i18n.t('main.empty')}}
        rowKey="id"
        size="small"
        pagination={{
          pageSize: 50
        }}
        className="car-park"
        rowClassName={() => ("car-park-row")}
      />
      <ModalShowRefuseReason text={refuseModalText} setIsShow={setShowRefuseReasonModal}
                             isShow={showRefuseReasonModal}/>

      <ModalEditLegalEntityNew
        isShow={isShowEditEntity}
        setIsShow={setShowEditEntity}
        legalEntityId={currentEntityId}
        consignorId={currentConsignorId}
        setLoadingList={() => {
        }}
        setStopListUpdate={setStopListUpdate}
      />
      <ModalEditLegalEntityConsignorGosLog
        isShow={isShowEditEntityDocs}
        setIsShow={setShowEditEntityDocs}
        legalEntityId={currentEntityId}
        consignorId={currentConsignorId}
        status = {currentStatus}
        onSubmitSuccess={(message) => {
          notification.success({
            message: i18n.t('Обновление статуса регистрации в ГосЛог'),
            description: message,
          });
          setStopListUpdate(false);
          setNeedUpdate(!needUpdate);
        }}
      />
    </Spinner>
  );
}
